




/*Get JSX Element To Do a Circle*/
import React from "react";

function getJSXCircle (value) {

    return value ?
        <span className="greenDot"/>
        : <span className="redDot"/>
}



/*Get JSX Element To Print a list*/
function getJSXList (values)  {
    let liItems = "";
    if (values !== undefined && values.length!== 0 && values[0]!== "")
    {
        liItems = values.map(item => { return <li key={item}>{item}</li>});
        return liItems;
    }
    else{
        return "None."
    }


}


export {getJSXCircle, getJSXList}